/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/Error/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsYellow200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.yellow.200'
        })
let dtColorsYellow900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.yellow.900'
        })
let constantData = 'Failed to sync patient: '
let cardErrorValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'error',
})
let aggregateData = fromAggregate.join(constantData, cardErrorValueData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="bottom"
 offsetMainAxis={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 cursor="pointer"
 backgroundColor={dtColorsYellow200}
 borderColor={dtColorsYellow200}
 color={dtColorsYellow900}
>
{childProps => (
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<TysiaIconWarning
{...childProps}
  viewPath={`${viewPath}/TysiaIconWarning`}
 fill={dtColorsYellow900}
 marginLeft={0}
 marginRight={0}
 width={16}
 height={16}
/>
)}
</TysiaTagIcon>
)}
</TysiaTag>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral900}
 height="auto"
 className="new-shadow"
 whiteSpace="normal"
 data="'Failed to sync patient: '"
 data="card.error"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}